'use strict';

module.exports = ['Casual', 'Charming', 'Local Spot', 'Historic', 'Rustic', 'Elegant', 'Ritzy', 'Trendy', 'Cozy', 'Eclectic', 'Hidden Gem', 'Modern', 'Stylish', 'Glamorous', 'Traditional', 'Bright', 'Retro', 'Old School', 'Functional'];